import { Component, Inject } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { TranslateModule } from '@ngx-translate/core';
import { ApplicationDataService } from '../../../../core/services/application-data.service';
import { AuthenticationService } from '../../../../core/services/authentication.service';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-reopen-dialog',
  standalone: true,
  imports: [ReactiveFormsModule, MatInputModule, MatButtonModule, TranslateModule, MatFormFieldModule, MatDialogModule],
  templateUrl: './reopen-dialog.component.html',
  styleUrl: './reopen-dialog.component.css'
})
export class ReopenDialogComponent {
  form: FormGroup;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ReopenDialogComponent>,
    public dialog: MatDialog,
    private formBuilder: FormBuilder,
    private appDataService: ApplicationDataService,
    private authService: AuthenticationService
  ) {}

  ngOnInit() {
    this.form = this.formBuilder.group({
      complaintId: [this.data?.complaintId, [Validators.required]],
      segmentId: [this.authService.getUserSegment()],
      comment: [''],
    });
  }

  close(submitted: boolean = false) {
    this.dialogRef.close({ submitted });
  }

  save() {
    if (this.form.invalid)
      return;

    // Find "Reopen" process ID from complaintProcessList
    const reopenProcess = this.data?.complaintProcessList?.find(
      (p: any) => p.name?.toLowerCase() === 'reopen'
    );

    const payload = {
      complaintId: this.data?.complaintId,
      comment: this.form.value.comment,
      currentProcessId: reopenProcess?.complaintProcessId
    };

    this.appDataService.updateComplaint(payload).subscribe({
      next: () => {
        this.close(true);
      },
      error: (e: any) => {
        console.error('Error reopening complaint:', e);
      }
    });
  }

  get f(): { [key: string]: AbstractControl } {
    return this.form.controls;
  }
}
